export const ACTIVITY_TYPE = {
  MESSAGE: 'MESSAGE',
  REQUEST_CREATED: 'REQUEST_CREATED',
  STATUS_CHANGED: 'STATUS_CHANGED',
  REASSIGNED: 'REASSIGNED',
} as const;
